import React from "react";
import { Box, Typography } from "@mui/material";

export default function NoTenantSelected({
  icon: Icon,
  title = "No training center selected",
  message = "Select a training center from the top bar to continue.",
}) {
  return (
    <Box sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
      {Icon && <Icon sx={{ fontSize: 48, mb: 2, opacity: 0.3 }} />}
      <Typography sx={{ fontSize: 15, fontWeight: 600, fontFamily: "var(--font-display)" }}>{title}</Typography>
      <Typography sx={{ fontSize: 13, mt: 1 }}>{message}</Typography>
    </Box>
  );
}
